import { FC } from "react"
import { TextField } from "@mui/material"
import "./styles.scss"
import { cleanPhone } from "../../../utils/phoneNumber"
import { usePhoneValidation } from "../../../hooks/usePhoneValidation"

type Props = {
  label: string
  value: string | undefined
  firstEndIcon?: string
  secondEndIcon?: string
  type: string
  index: string
  onChange: (value: string, type: string, index: string) => void;
  isRequired?: boolean;
  isError?: boolean
}

/**
 * Plain text field, stripped as you type and checked loosely on blur — no country or prefix
 * handling of any kind. See CreateHouseholdPage/PhoneNumberInput.
 */
export const PhoneNumberInput: FC<Props> = ({
  label,
  value,
  firstEndIcon,
  secondEndIcon,
  type,
  index,
  onChange,
  isRequired,
  isError
}) => {
  const phone = usePhoneValidation(value)
  // `isError` from the parent (a required-but-empty field) still wins.
  const showError = isError || phone.isError

  return (
    <div className="visit-report-phone-number-input__input-container">
      <label className="visit-report-phone-number-input__label">{label}{isRequired && <span style={{ color: "red" }}>*</span>}</label>
      <div className="visit-report-phone-number-input__end-icon-container">
        {firstEndIcon && (
          <label className="visit-report-phone-number-input__end-icon">
            <img src={firstEndIcon} alt="end-icon" />
          </label>
        )}
        {secondEndIcon && (
          <label className="visit-report-phone-number-input__end-icon">
            <img src={secondEndIcon} alt="end-icon" />
          </label>
        )}
      </div>
      <TextField
        className="visit-report-phone-number-input__tel"
        type="tel"
        inputProps={{ inputMode: "tel", autoComplete: "tel" }}
        fullWidth
        error={showError}
        helperText={phone.helperText}
        value={value ?? ""}
        onBlur={phone.onBlur}
        onChange={(e) => {
          phone.onEdit()
          onChange(cleanPhone(e.target.value), type, index)
        }}
      />
    </div>
  )
}
